// import { statusIcons } from "../../../constants/constants";
// import { useAuth } from "../../context/Auth";
// import { RupeeIcon } from "../../icons/Icon";
// import styles from "./DealerStyles.module.css";

// const DealerStatusCard = ({
//   statusText,
//   statusItemCount,
//   dealerStatus,
//   statusAllCount,
//   type,
//   amount,
// }) => {
//   const { mode, designations } = useAuth();
//   const textColor = mode ? "#FFFFFF" : "#646B88";
//   const cardStyles = mode
//     ? {
//         backgroundColor: "#1B1D21",
//         color: "#fff",
//         borderColor: "#1B1D21",
//       }
//     : {};

//   const renderStatusIcon = () =>
//     statusIcons[dealerStatus || statusText] || <RupeeIcon />;

//   const showAllTimeCount =
//     type === "receipt" || type === "order"; /* || type === "dispatch" */

//   const showAllTimeAmount =
//     type === "receipt" ||
//     (type === "order" && designations.includes("superadmin")); /* ||
//     (type === "dispatch" && designations.includes("superadmin")); */

//   return (
//     <div className={styles.status_card} style={cardStyles}>
//       <div className={styles.text_con}>
//         {renderStatusIcon()}
//         {showAllTimeAmount && <p className={styles.small_txt}>₹ {amount}</p>}
//       </div>

//       <p className={styles.status_txt} style={{ color: textColor }}>
//         {statusText}
//       </p>

//       <p className={styles.bold_txt} style={{ color: textColor }}>
//         {statusItemCount}
//       </p>

//       {showAllTimeCount && (
//         <p className={styles.small_txt} style={{ color: "#757575" }}>
//           Prev {statusAllCount}
//         </p>
//       )}
//     </div>
//   );
// };

// export default DealerStatusCard;

import { statusIcons } from "../../../constants/constants";
import { useAuth } from "../../context/Auth";
import { RupeeIcon } from "../../icons/Icon";
import styles from "./DealerStyles.module.css";

const DealerStatusCard = ({
  statusText,
  statusItemCount,
  dealerStatus,
  statusAllCount,
  type,
  amount,
}) => {
  const { mode, designations } = useAuth();
  const textColor = mode ? "#FFFFFF" : "#646B88";
  const cardStyles = mode
    ? {
        backgroundColor: "#1B1D21",
        color: "#fff",
        borderColor: "#1B1D21",
      }
    : {};

  const renderStatusIcon = () =>
    statusIcons[dealerStatus || statusText] || <RupeeIcon />;

  const showAllTimeCount =
    type === "receipt" ||
    type === "order" ||
    type === "dispatch" ||
    type === "Production & Sale";

  const showAllTimeAmount =
    type === "receipt" ||
    (type === "order" && designations.includes("superadmin")) ||
    (type === "dispatch" && designations.includes("superadmin")) ||
    (type === "Production & Sale" && designations.includes("superadmin"));

  return (
    <div className={styles.status_card} style={cardStyles}>
      <div className={styles.text_con}>
        {renderStatusIcon()}
        {showAllTimeAmount && <p className={styles.small_txt}>₹ {amount}</p>}
      </div>

      <p className={styles.status_txt} style={{ color: textColor }}>
        {statusText}
      </p>

      <p className={styles.bold_txt} style={{ color: textColor }}>
        {statusItemCount}
      </p>

      {showAllTimeCount && (
        <p className={styles.small_txt} style={{ color: "#757575" }}>
          Prev {statusAllCount}
        </p>
      )}
    </div>
  );
};

export default DealerStatusCard;
